module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticClass: "pa_look_img_list"
  }, [_vm._l((_vm.imgData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cols"
    }, [_c('el-image', {
      staticClass: "img",
      style: ({
        height: _vm.imgHeight + 'px'
      }),
      attrs: {
        "src": _vm.appendImg(item.file_path, 100, 100),
        "fit": "cover"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "del",
      on: {
        "click": function($event) {
          return _vm.imgDelTap(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-close"
    })])], 1)
  }), _vm._v(" "), (_vm.imgData.length < _vm.limit) ? _c('div', {
    staticClass: "cols"
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.$config.upload_img_url,
      "multiple": "",
      "accept": ".jpg,.gif,.png,.jpeg",
      "data": _vm.fromData,
      "limit": _vm.limit,
      "before-upload": _vm.beforeUpload,
      "show-file-list": false,
      "on-success": _vm.uploadSuccessTap
    }
  }, [_c('div', {
    staticClass: "pa_look_add_btn"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])])], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "16px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "8px",
      "color": "#BBBBBB"
    }
  }, [_vm._v("\n\t\t\t\t最多传" + _vm._s(_vm.limit) + "张，支持JPG，PNG格式，单张图片小于" + _vm._s(_vm.size) + "MB，"), _c('br')])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-674ea97c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/uploads/uploadImg.vue
// module id = 3505
// module chunks = 103